
	/*!
  * tiptap vundefined
  * (c) 2018 Scrumpy UG (limited liability)
  * @license MIT
  */

import { findParentNode } from 'prosemirror-utils';

function getMarkAttrs (state, type) {
	var ref = state.selection;
	var from = ref.from;
	var to = ref.to;
	var marks = [];

	state.doc.nodesBetween(from, to, function (node) {
		marks = marks.concat( node.marks);
	});

	var mark = marks.find(function (markItem) { return markItem.type.name === type.name; });

	if (mark) {
		return mark.attrs
	}

	return {}
}

function markIsActive (state, type) {
	var ref = state.selection;
	var from = ref.from;
	var $from = ref.$from;
	var to = ref.to;
	var empty = ref.empty;

	if (empty) {
		return !!type.isInSet(state.storedMarks || $from.marks())
	}

	return !!state.doc.rangeHasMark(from, to, type)
}

function nodeIsActive (state, type, attrs) {
	if ( attrs === void 0 ) attrs = {};

	var predicate = function (node) { return node.type === type; };
	var parent = findParentNode(predicate)(state.selection);

	if (!Object.keys(attrs).length || !parent) {
		return !!parent
	}

	return parent.node.hasMarkup(type, attrs)
}

export { getMarkAttrs, markIsActive, nodeIsActive };
